import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import seo_img from '../img/subdomen/nigeria_character_seo.svg'
import seo_img_2 from '../img/seo/seo-2.svg'

import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Seo extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);
	}

	render() {
		return (
			<div>

				<Helmet
					title="Writing Jobs From Home. Part time jobs Nigeria.UvoCorp.com - Nigeria.UvoCorp.com"
					meta={[
						{ name: "description", content: "Work at home jobs for freelance writers. Good writing job for English native speakers at Nigeria.UvoCorp.com Registration is free" },

						{ property: 'og:title', content: "Writing Jobs From Home. Part time jobs Nigeria.UvoCorp.com - Nigeria.UvoCorp.com" },
						{ property: 'og:description', content: "Work at home jobs for freelance writers. Good writing job for English native speakers at Nigeria.UvoCorp.com Registration is free" },
						{ property: 'og:site_name', content: "Nigeria.UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://nigeria.uvocorp.com/writing_jobs_from_home.html" },
						{ rel: 'alternate', href: "https://www.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en" },
						{ rel: 'alternate', href: "https://canada.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ca" },
						{ rel: 'alternate', href: "https://hongkong.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-hk" },
						{ rel: 'alternate', href: "https://india.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-in" },
						{ rel: 'alternate', href: "https://nigeria.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ng" },
						{ rel: 'alternate', href: "https://pakistan.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-pk" },
						{ rel: 'alternate', href: "https://philippines.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ph" },
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper subdomen">
				
					<div className="inner-header">
						<div className="container">
							<div className="subdomen-header-title">
								<p>ACADEMIC WRITING ASSISTANCE AGENCY</p>
								<h1>Writing Jobs From Home in Nigeria</h1>
							</div>
							
							<a href={`${process.env.GATSBY_API_URL}/register_email.html`}>Register now</a>
						</div>
					</div>

					<div className="home-benefits home-block hiring-benefits">
						<div className="container">
							<h1>The benefits you enjoy working as a freelance writer:</h1>
							<ul className="home-benefits-list">
								<li className="home-benefits-1">
									<p>No registration fees</p>
								</li>
								<li className="home-benefits-2">
									<p>High wages</p>
								</li>
								<li className="home-benefits-3">
									<p>Working from home</p>
								</li>
								<li className="home-benefits-4">
									<p>Orders in the sphere <br />of your interest</p>
								</li>
								<li className="home-benefits-5">
									<p>24/7 available <br />support team</p>
								</li>
								<li className="home-benefits-6">
									<p>Payments always <br />on time</p>
								</li>
								<li className="home-benefits-7">
									<p>Manage your time <br />and workload yourself</p>
								</li>
							</ul>
						</div>
					</div>

					<div className="home-pricing-info">
						<div className="container">
							<p>There is no other company that offers <strong>$15</strong>/page written by an <span className="home-pricing-info-role">ESL</span> writer and <strong>$26</strong>/page completed by an <span className="home-pricing-info-role">ENL</span> writer.</p>
							<a href={`${process.env.GATSBY_API_URL}/prices.html`}>View Pricing <svg id="arrow-right" width="22" height="22"><path fill="#black" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></a>
						</div>
					</div>

					<div className="inner-white hiring seo">
						<div className="container">
							<h2>Writers wanted</h2>
							<div className="row">
								<div className="col-md-9">
									<p>Dear potential <a href={`${process.env.GATSBY_API_URL}`}>UVOCORP</a> writers, we are currently hiring:</p>
									<ol className="hiring-steps">
										<li>Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);</li>
										<li>English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;</li>
										<li>Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:</li>
									</ol>
								
									<ul className="hiring-disciplines">
										<li className="discipline_8">Accounting</li>
										<li className="discipline_15">Architecture, Building and Planning</li>
										<li className="discipline_14">Biology (and other Life Sciences)</li>
										<li className="discipline_13">Chemistry</li>
										<li className="discipline_1">Engneering</li>
										<li className="discipline_10">Civil Engineering</li>
										<li className="discipline_7">Computer Science</li>
										<li className="discipline_5">IT, Web</li>
										<li className="discipline_3">Finance</li>
										<li className="discipline_11">Mathematics</li>
										<li className="discipline_12">Physics</li>
										<li className="discipline_4">Statistics</li>
									</ul>
								</div>
								<div className="hiring-img">
									<img src={seo_img_2} alt="Seo Image"/>
								</div>
							</div>

							<div className="row seo-row">

								<div className="col-md-4 seo-img-container">
									<div className="seo-img">
										<img src={seo_img} alt="Seo Image"/>
									</div>
								</div>
								<div className="col-md-8">
									<p>Many people have jobs but not every person has a job that he or she is actually satisfied with, in regard to the amount of money that he or she is making from the job. To make things even tougher, jobs are not that easy to come across so many people cannot get second jobs, but this does not mean that part time jobs are not available. One place where you will never have a shortage of extra jobs to engage in is online, particularly on <Link to="/" title="Nigeria.UvoCorp.com">Nigeria.UvoCorp.com</Link>.  Once you get an account with this company, you will no longer be sitting at home, when not at work, wishing that you could make some extra cash but instead, you will go ahead and make the extra cash that you need. It gets more interesting because in the days when you are not at work, you can decide to engage in writing jobs from home for longer periods of time, rather than getting bored the whole day and wondering what to do with your free time. This website gives you the chance to make money at your regular place of work from home. Also, you can make some money to help you with your everyday responsibilities.</p>

									<p>There are so many other advantages that you get when you decide not to just sit at home, but to work from home. One advantage is the chance to make money while your mind is relaxed and when your body is very comfortable. It is true that people who work from home feel most comfortable and relaxed, and however friendly the office environment might be, it can never really compare to the atmosphere in homes. With no boss to shout or place demands on you and no pesky workmates who love to stick their nose into your business,  you get to dictate the environment that you want and work under your own terms, as long as the demands of your orders are met. Working from home also saves you from many of the problems that you would otherwise encounter by commuting daily to some office, including the diseases that could be passed to you while on the public transport system, and the stress that you would experience during traffic jams. Imagine using your free time and skills to make extra money without much of a hassle, because that is the opportunity given to you here.</p>

								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<a href={`${process.env.GATSBY_API_URL}/register_email.html`}>Start registration</a>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/writing_jobs_from_home.html.js